import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { getCV } from '../actions/portfolioActions'
import CVSection from './sections/CVSection'

function CVPage() {
  const dispatch = useDispatch()
  useEffect(() => { dispatch(getCV()) }, [dispatch])
  return <CVSection />
}

export default CVPage
